import { ArrowLeftIcon } from "@heroicons/react/solid";
import React from "react";
import { useTranslation } from "react-i18next";
import { useQuery } from "react-query";
import { showCandidate } from "../../api/endpoints/candidate/cadidates";
import { listCandidateCourses } from "../../api/endpoints/candidate/courses";
import CandidateCourseModel from "../../api/models/CandidateCourseModel";
import CandidateModel from "../../api/models/CandidateModel";
import LearnDashUserModel from "../../api/models/LearnDashUserModel";
import { showApiErrorMessages } from "../../helpers";
import LevelProgressCard from "../sessions/LevelProgressCard";
import { useAuth } from "../../context/AuthContext";

const LEARN_DASH_URL = process.env.REACT_APP_LEARN_DASH_BASE_URL;
export default function SelfLearningPlatform() {
  const { t } = useTranslation("", {
    keyPrefix: "page.candidate.dashboard.homepage",
  });
  const { currentUser }: any = useAuth();
  const { data: courses, isLoading } = useQuery(
    "candidateCourses",
    () => listCandidateCourses("Candidate", currentUser?.id),
    {
      select: (response) => {
        let courses: CandidateCourseModel[] = [];
        if (response.isSuccess) {
          courses = CandidateCourseModel.fromApiResponse(response.data);
        } else {
          showApiErrorMessages(response);
        }
        return courses;
      },
    }
  );
  const { data: learnDashUser } = useQuery("learnDashUser", showCandidate, {
    staleTime: Infinity,
    select: (response) => {
      let learnDashUser: LearnDashUserModel | null = null;
      if (response.isSuccess) {
        const candidate: CandidateModel = CandidateModel.fromApiResponse(
          response.data
        );
        learnDashUser = candidate.learnDashUser;
      } else {
        showApiErrorMessages(response);
      }
      return learnDashUser;
    },
  });

  return (
    <div className="w-full flex flex-col gap-6">
      <div className="flex flex-col  gap-4">
        <div className="w-full flex items-center justify-between">
          <h3 className="text-lg leading-6 font-medium text-gray-700">
            {t("selfLearning")}
          </h3>
          <form
            action={`${LEARN_DASH_URL}/wp-login.php`}
            method="POST"
            target="_blank"
          >
            <input type="hidden" name="log" value={learnDashUser?.email} />
            <input type="hidden" name="pwd" value={learnDashUser?.password} />
            <input
              type="hidden"
              name="redirect_to"
              value={`${LEARN_DASH_URL}/ar/ld-groups/${learnDashUser?.slug}/`}
            />
            <button
              type="submit"
              className="w-fit inline-flex items-center rounded-md border border-transparent bg-brandblue-600  px-4 py-2.5 text-sm font-medium leading-4 text-white shadow-sm hover:bg-brandblue-700 focus:outline-none focus:ring-2 focus:ring-brandblue-500 focus:ring-offset-2"
            >
              <span className="hidden md:flex"> {t("enterLearnDash")}</span>
              <ArrowLeftIcon
                className="md:ltr:ml-2 md:ltr:-mr-0.5 md:rtl:mr-2 md:rtl:-ml-0.5 h-5 w-5 ltr:rotate-180"
                aria-hidden="true"
              />
            </button>
          </form>
        </div>
        <p className="text-base font-normal text-gray-400">
          {t("description")}
        </p>
      </div>
      <div className="w-full">
        <div className="w-full mb-6">
          <h2 className=" text-gray-700 text-lg font-semibold   leading-6">
            {t(`levelInProgress`)}
          </h2>
        </div>
        <div className="w-full flex flex-col gap-4">
          {React.Children.toArray(
            courses?.map((course) => (
              <LevelProgressCard
                numberOfLevels={course.totalSteps}
                finishedLevels={course.stepsCompleted}
                levelTitle={course.title}
              />
            ))
          )}
        </div>
      </div>
    </div>
  );
}
